import { Component, OnInit } from "@angular/core";
import { SignaturesService } from "../signatures.service";
import { ToastrService } from "../../shared/toastr.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-placeholders",
  templateUrl: "./placeholders.component.html",
  styleUrls: ["./placeholders.component.scss"],
  standalone: false,
})
export class PlaceholdersComponent implements OnInit {
  companyPlaceholders: string[] = [];
  userPlaceholders: string[] = [];
  phoneNumberPlaceholders: string[] = [];
  otherPlaceholders: string[] = [];
  placeholders: string[] = [];

  constructor(
    private service: SignaturesService,
    private toastr: ToastrService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    void this.service
      .placeholders()
      .toPromise()
      .then((response: unknown) => {
        const placeholders = response as string[];
        this.placeholders = placeholders;

        this.companyPlaceholders = placeholders.filter((placeholder) =>
          placeholder.startsWith("${company"),
        );
        this.userPlaceholders = placeholders.filter(
          (placeholder) =>
            placeholder.startsWith("${user") ||
            placeholder.startsWith("${job") ||
            placeholder.startsWith("${labelUser"),
        );
        this.phoneNumberPlaceholders = [
          ...placeholders.filter((placeholder) =>
            placeholder.includes("obileNumber"),
          ),
          ...placeholders.filter((placeholder) =>
            placeholder.includes(`honeNumber`),
          ),
        ];

        const usedPlaceholders = [
          ...this.companyPlaceholders,
          ...this.userPlaceholders,
          ...this.phoneNumberPlaceholders,
        ];
        this.otherPlaceholders = placeholders.filter(
          (placeholder) => !usedPlaceholders.includes(placeholder),
        );
      });
  }

  copyPlaceholderToClipboard = (placeholder: string) => {
    void navigator.clipboard.writeText(placeholder);
    this.toastr.success(
      this.translate.instant("footers.copyPlaceholderSuccess") as string,
    );
  };
}
